import { CosmosClient } from "@azure/cosmos";

import { authProvider } from '../utils/authProvider';

const endpoint: string = "https://cosmosonlinecpd.documents.azure.com/"; // Add your endpoint
const key: string = "3diEX4VIKXZNUt5dHY51UJIGLxjZgTXeZA8U6lJF0SjZc9GgHiOSaH4itBOq8zGSM3Ixje60PBIMvm6raa1TPg=="; // Add the masterkey of the endpoint

export class UserCourseUtil {

  public async CreateMyCourse(_document: any) {
    let accountInfo = await authProvider.getAccountInfo();
    let email = accountInfo === null ? '' : accountInfo?.account.idToken.email;

    let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
    //let API_ENDPOINT = '/UserColCreate?code=zS8qP1sdjudYSeaZJhGHuaDzMGxmVFVFaHtiUDGklbIg7bvYDr2rTw==';
    let API_ENDPOINT = '/UserColCreateMyCourse?code=XRy2yPiN1/nOU7r4j18pxnIXKu9TCK6N1mzysx7ZwkTeaCAamiOD4Q==';
    //console.log("JwtIdToken : " + accountInfo?.jwtIdToken);
    let API = API_URL + API_ENDPOINT;
    let response = await fetch(API,
      {
        method: "post",
        headers: new Headers({
          "Authorization": "Bearer " + accountInfo?.jwtIdToken,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(_document)
      }
    );

    // if (response.ok) {
    //   let result = await response.json();
    //   return result;
    // } else {
    //   return { _document};
    // }
    if (response.ok) {
      let result = await response.json();
      if (result.isSuccess) {
          return result; // Newly created document
      } else {
          return { errors : result.errors };
      }
    } else {
        // Error return from Azure Fucntion
        let errorResponse = await response.json();
        return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
    }
  }

  public async AskTrainer(_document: any) {
    let accountInfo = await authProvider.getAccountInfo();
    let email = accountInfo === null ? '' : accountInfo?.account.idToken.email;

    let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
    let API_ENDPOINT = '/SendTrainerEmail?code=uLYZAwnqDWGK3DKRH3dcaWvH1clY41pc5v4HxsSelYypCVik8AtwIA==';
    let API = API_URL + API_ENDPOINT;
    let response = await fetch(API,
      {
        method: "post",
        headers: new Headers({
          "Authorization": "Bearer " + accountInfo?.jwtIdToken,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(_document)
      }
    );

    if (response.ok) {
      let result = await response.json();
      return result;
    } else {
      return { ...accountInfo?.account, id: _document.oId };
    }
  }
}
